import React from 'react';

import { HNCoreFrontendWebForside } from '../../types/Resources';

import TjenestepanelCoreCms from '@helsenorge/core-cms/tjenestepanel-v2';
import { AuthenticatedTiles } from '@helsenorge/core-cms/types/entities/Helsenorge.CoreFrontend.InternalApiEntities';
import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';

import enResources from '../../resources/HN.CoreFrontend.Web.Forside.en-GB.json';
import nbResources from '../../resources/HN.CoreFrontend.Web.Forside.nb-NO.json';
import seResources from '../../resources/HN.CoreFrontend.Web.Forside.se-NO.json';

const getResources = (language: 'no' | 'en' | 'se'): HNCoreFrontendWebForside => {
  switch (language) {
    case 'no':
      return nbResources;
    case 'en':
      return enResources;
    case 'se':
      return seResources;
    default:
      return nbResources;
  }
};

interface Props {
  language: 'no' | 'en' | 'se';
  favorites: AuthenticatedTiles[] | null;
  groups: AuthenticatedTiles[] | null;
}

const Tjenestepanel: React.FunctionComponent<Props> = (props: Props) => {
  const resources = getResources(props.language);

  return (
    <TjenestepanelCoreCms
      titleId={getSidetittelId()}
      showMore={resources.tjenestepanelVisFlere}
      showLess={resources.tjenestepanelVisFarre}
      favorites={props.favorites}
      groups={props.groups}
    />
  );
};

export default Tjenestepanel;
